import { render, staticRenderFns } from "./SealDetail.vue?vue&type=template&id=cccb20b6&"
import script from "./SealDetail.vue?vue&type=script&lang=js&"
export * from "./SealDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports